import LoginRedirect from "./LoginRedirect";
import Waitlist from "./../../assets/Waitlist.png";

const Message = () => {
  return (
    <>
      <img
        src={Waitlist}
        alt="AccountWaitlist"
        style={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
        }}
      />
      <LoginRedirect />
    </>
  );
};
export default Message;
